import { formatCurrency } from '@/pages/table/utils/utils';
import usdt from '../../../assets/profile/tether.svg';

interface TokenBalanceProps {
  tokenBalance: any | null;
  tokenName: string;
  chain: string;
}

// TODO img to use will be from some API, waiting for feature
const TokenBalance = ({ tokenBalance, tokenName, chain }: TokenBalanceProps) => {
  return (
    <div className="flex w-full items-center justify-between gap-1">
      <div className="flex items-center gap-2">
        <img src={usdt} alt="usdt" className="h-[24px] w-[24px]" />

        <div className="flex flex-col">
          <span className="font-manrope text-sm font-semibold text-ph-gray-white">{tokenName}</span>
          <span className="font-manrope text-xs text-ph-gray-jumbo">{chain}</span>
        </div>
      </div>

      <span className="font-manrope text-base font-semibold text-ph-gray-white">
        {tokenBalance ? formatCurrency(tokenBalance.displayBalance) : '-'}
      </span>
    </div>
  );
};

export default TokenBalance;
